// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateDashboardModalSecondStep {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing_unit_6);
}
.CreateDashboardModalSecondStep .CreateDashboardModalSecondStep-label {
  display: inline-block;
  font-size: 12px;
  color: var(--color_neutral_800);
  margin-bottom: var(--spacing_unit_2);
}
.CreateDashboardModalSecondStep .CreateDashboardModalSecondStep-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  gap: var(--spacing_unit_4, 16px);
}
.CreateDashboardModalSecondStep .CreateDashboardModalSecondStep-footer > :first-child {
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardModals/CreateDashboardModal/components/CreateDashboardModalSecondStep/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,qBAAA;EACA,eAAA;EACA,+BAAA;EACA,oCAAA;AACJ;AAEE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EAAA,gCAAA;AAAJ;AAEI;EACE,kBAAA;AAAN","sourcesContent":[".CreateDashboardModalSecondStep {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--spacing_unit_6);\n\n  .CreateDashboardModalSecondStep-label {\n    display: inline-block;\n    font-size: 12px;\n    color: var(--color_neutral_800);\n    margin-bottom: var(--spacing_unit_2);\n  }\n\n  .CreateDashboardModalSecondStep-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: var(--spacing_unit_4, 16px);\n\n    & > :first-child {\n      margin-right: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
